import {Injectable} from 'ng-metadata/core';
import {Inject}  from 'ng-metadata/core';
import {AddQueryToSavedSearchesService} from "../../search/savedQueries/addQueryToSavedSearches/addQueryToSavedSearches.service";


@Injectable()
export class SilentLoginService {

    private silentLoginProgressDeferedObject: angular.IDeferred;
    private APP_DELAY_TIME = 4500;
    private _silentLoginAppDelayTimer: angular.IPromise<>;

    constructor(@Inject('$mdToast') private $mdToast: ng.material.IToastService,
                @Inject('$q') private $q: ng.IQService,
                @Inject('$timeout') private $timeout: ng.ITimeoutService,
                private addQueryToSavedSearchesService: AddQueryToSavedSearchesService) {
        this._silentLoginAppDelayTimer = this.$timeout(()=>{}, this.APP_DELAY_TIME);
        this.silentLoginProgressDeferedObject = this.$q.defer();
    }

    ngOnInit() {
    }

    public showSilentLoginToast(){
        let templateString = '<prm-silent-login-alert-toast></prm-silent-login-alert-toast>';
        this.$mdToast.show({
            hideDelay   : false,
            position    : 'top right',
            template : templateString
        }).then(()=>{
            this.addQueryToSavedSearchesService.onToastClose();
        });
    }

    silentLoginEnd(){
        this.$timeout.cancel(this.silentLoginAppDelayTimer);
        this.silentLoginProgressDeferedObject.resolve();
    }

    get silentLoginInprogressPromise(){
        return this.silentLoginProgressDeferedObject? this.silentLoginProgressDeferedObject.promise : undefined;
    }

    get silentLoginAppDelayTimer(){
        return this._silentLoginAppDelayTimer;
    }





}




// WEBPACK FOOTER //
// ./src/main/webapp/components/primoExplore/silentLogin/silentLogin.service.ts